module.exports = __webpack_public_path__ + "img/103_3.5d3722da.png";